import { render, staticRenderFns } from "./NotifyWrapper.vue?vue&type=template&id=56ed00fa"
import script from "./NotifyWrapper.vue?vue&type=script&lang=js"
export * from "./NotifyWrapper.vue?vue&type=script&lang=js"
import style0 from "./NotifyWrapper.vue?vue&type=style&index=0&id=56ed00fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports